var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCrossedEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 23,
    viewBox: "0 0 24 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9433 13.0267C13.6915 13.2968 13.3879 13.5136 13.0506 13.6639C12.7133 13.8142 12.3491 13.895 11.9799 13.9015C11.6106 13.908 11.2439 13.8401 10.9014 13.7018C10.559 13.5635 10.248 13.3576 9.98682 13.0965C9.72568 12.8353 9.51982 12.5243 9.38151 12.1819C9.2432 11.8394 9.17527 11.4727 9.18179 11.1034C9.1883 10.7342 9.26912 10.37 9.41943 10.0327C9.56973 9.69536 9.78644 9.39176 10.0566 9.14M1.91663 1L22.0833 21.1667M17.445 16.5283C15.878 17.7228 13.97 18.3845 12 18.4167C5.58329 18.4167 1.91663 11.0833 1.91663 11.0833C3.05686 8.9584 4.63833 7.10189 6.55496 5.63833L17.445 16.5283ZM10.075 3.97C10.7059 3.82231 11.3519 3.74848 12 3.75C18.4166 3.75 22.0833 11.0833 22.0833 11.0833C21.5269 12.1243 20.8633 13.1043 20.1033 14.0075L10.075 3.97Z",
    stroke: "#A5B3BD",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossedEye);
export default __webpack_public_path__ + "static/media/crossed-eye.f509c5c57515f5c5f2e2d9f268f1ae1c.svg";
export { ForwardRef as ReactComponent };